"use strict";

var _templateObject;
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey2(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey2(t) { var i = _toPrimitive2(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive2(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.PreviousPage = void 0;
var _tsRes = require("ts-res"),
  _utilities = require("../../utilities"),
  _kameleoonData = require("../../kameleoonData"),
  _types = require("../types"),
  _logging = require("../../logging");
function _defineProperty(a, b, c) {
  return (b = _toPropertyKey(b)) in a ? Object.defineProperty(a, b, {
    value: c,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : a[b] = c, a;
}
function _toPropertyKey(a) {
  var b = _toPrimitive(a, "string");
  return "symbol" == _typeof(b) ? b : b + "";
}
function _toPrimitive(a, b) {
  if ("object" != _typeof(a) || !a) return a;
  var c = a[Symbol.toPrimitive];
  if (void 0 !== c) {
    var d = c.call(a, b || "default");
    if ("object" != _typeof(d)) return d;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === b ? String : Number)(a);
}
var PreviousPage = /*#__PURE__*/function () {
  function PreviousPage(a) {
    _classCallCheck(this, PreviousPage);
    var b = a.matchType,
      c = a.url;
    _defineProperty(this, "conditionValue", void 0), _defineProperty(this, "matchType", void 0), this.conditionValue = c, this.matchType = b;
  }
  return _createClass(PreviousPage, [{
    key: "evaluate",
    value: function evaluate(a) {
      var b = a.targetingData;
      var c = null === b || void 0 === b ? void 0 : b[_kameleoonData.KameleoonData.PageView];
      if (!c) return (0, _tsRes.Ok)(!1);
      var d = this.getSecondLatestPageView(Object.values(c));
      if (!d) return (0, _tsRes.Ok)(!1);
      var e = d.urlAddress;
      return (0, _tsRes.Ok)(this.checkCondition(e));
    }
  }, {
    key: "checkCondition",
    value: function checkCondition(a) {
      if (!this.matchType || !this.conditionValue) return !1;
      switch (this.matchType) {
        case _types.MatchType.CONTAINS:
          return a.includes(this.conditionValue);
        case _types.MatchType.EXACT:
          return a === this.conditionValue;
        case _types.MatchType.REGULAR_EXPRESSION:
          return _utilities.Parser.parseRegExp(this.conditionValue).test(a);
        default:
          return _logging.KameleoonLogger.error(_templateObject || (_templateObject = _taggedTemplateLiteral(["Unexpected comparing operation for PreviousPage condition: ", ""])), this.matchType), !1;
      }
    }
  }, {
    key: "getSecondLatestPageView",
    value: function getSecondLatestPageView(a) {
      if (2 > a.length) return;
      var b, c;
      return a.forEach(function (a) {
        var d = a.timestamps[a.timestamps.length - 1].time;
        if (!b) return void (b = a);
        var e = b.timestamps[b.timestamps.length - 1].time;
        if (d > e) return c = b, void (b = a);
        var f = c ? c.timestamps[c.timestamps.length - 1].time : 0;
        d > f && (c = a);
      }), c;
    }
  }]);
}();
exports.PreviousPage = PreviousPage;